import { SET_COUNTIES, SET_ACCOUNT_TYPES, SET_ROUTING_TYPES, SET_ORGANIZATION_DATA } from './actionTypes';

let initialState = {
    countries: [],
    accountTypes: null,
    routingTypes: null,
    organizationData: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COUNTIES:
            return {
                ...state,
                countries: action.payload || []
            };
        case SET_ACCOUNT_TYPES:
            return {
                ...state,
                accountTypes: action.payload || null
            };
        case SET_ROUTING_TYPES:
            return {
                ...state,
                routingTypes: action.payload || null
            };
        case SET_ORGANIZATION_DATA:
            return {
                ...state,
                organizationData: action.payload || null
            };
        default:
            break;
    }
    return state;
};

export default reducer;

